// extracted by mini-css-extract-plugin
module.exports = {"root":"CtaLink_root__B8HHv","box":"CtaLink_box__26ipe"};